import { render, staticRenderFns } from "./ContestLink.vue?vue&type=template&id=779acaac&"
import script from "./ContestLink.vue?vue&type=script&lang=js&"
export * from "./ContestLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports